import React from "react";
import { formatDate, getNumberFromString } from "../../utilities/utils";
import { Link } from "react-router-dom";
import { ArrowDownTrayIcon } from "@heroicons/react/24/outline";

const getStatusClasses = (status) => {
  switch (status) {
    case "Paid":
    case "paid":
      return "bg-[#16CA7C] text-white";
    case "Delinquent":
    case "delinquent":
      return "bg-[#EF2121] text-white";
    case "Past Due":
    case "past due":
      return "bg-[#D85B34] text-white";
    case "Credited":
    case "credited":
      return "bg-[#FFD912] text-customGray";
    case "Partial Refund":
    case "partial refund":
      return "bg-[#D834A0] text-white";
    case "Full Refund":
    case "full refund":
      return "bg-[#7D34D8] text-white";
    default:
      return "bg-customGray text-white";
  }
};

const ProfessionalInvoiceTable = ({ invoiceData, userData }) => {
  const professionNames = userData?.data?.professions.map(
    (profession) => profession.name
  );

  return (
    <>
      <div className="border border-solid border-[#EBEFF3] rounded-md p-5 hidden md:block bg-[#ffffff]">
        <div className="flow-root">
          <div className="overflow-x-auto">
            <div className="inline-block min-w-full align-middle">
              <table className="min-w-full divide-y divide-gray-300">
                <thead>
                  <tr>
                    <th
                      scope="col"
                      className="py-3.5 pl-4 pr-3 text-left text-sm font-bold text-[#485868] leading-[160%] sm:pl-0"
                    >
                      Invoice number
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-bold text-[#485868] leading-[160%]"
                    >
                      Amount
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-bold text-[#485868] leading-[160%]"
                    >
                      Credits Added
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-bold text-[#485868] leading-[160%]"
                    >
                      Created Date
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-bold text-[#485868] leading-[160%]"
                    >
                      Status
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-bold text-[#485868] leading-[160%]"
                    >
                      Invoice
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 bg-white">
                  {invoiceData &&
                    invoiceData.map((person) => (
                      <tr key={person.id}>
                        <td className="whitespace-nowrap py-5 pl-4 pr-3 text-sm leading-[140%] sm:pl-0">
                          <div className="text-customGray">{person.number}</div>
                        </td>
                        <td className="whitespace-nowrap px-3 py-5 text-sm leading-[140%]">
                          <div className="text-customGray">
                            ${person.amount}
                          </div>
                        </td>
                        <td className="whitespace-nowrap py-5 pl-4 pr-3 text-sm leading-[140%]">
                          <div className="text-customGray">
                            {getNumberFromString(person.description)}
                          </div>
                        </td>
                        <td className="whitespace-nowrap px-3 py-5 text-sm leading-[140%] text-customGray">
                          {formatDate(person.created_at)}
                        </td>
                        <td className="whitespace-nowrap px-3 py-5">
                          <span
                            className={`inline-flex items-center capitalize rounded-md px-[10px] py-1 text-xs font-bold leading-[160%] ${getStatusClasses(
                              person.status
                            )}`}
                          >
                            {person.status}
                          </span>
                        </td>
                        {person.invoice_pdf && (
                          <td className="whitespace-nowrap py-5 pl-4 pr-3 text-sm font-bold leading-[140%] text-primary flex items-center gap-[10px] ">
                            <ArrowDownTrayIcon
                              onClick={() =>
                                window.open(person.invoice_pdf, "_self")
                              }
                              className="w-6 h-6 text-primary inline-block cursor-pointer"
                            />
                          </td>
                        )}
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div className="block md:hidden">
        <div>
          <ul>
            {invoiceData &&
              invoiceData.slice(0, 3).map((person) => (
                <li className="border border-solid border-[#EBEFF3] rounded-md p-5 mb-[14px] flex justify-between bg-[#ffffff]">
                  <ul>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        Invoice #
                      </h6>
                      <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                        {person.number}
                      </span>
                    </li>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        Amount
                      </h6>
                      <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                        ${person.amount}
                      </span>
                    </li>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        Credits Added
                      </h6>
                      <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                        {getNumberFromString(person.description)}
                      </span>
                    </li>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        Created Date
                      </h6>
                      <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                        {formatDate(person.created_at)}
                      </span>
                    </li>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        Profession
                      </h6>
                      <span className="text-sm font-normal leading-[160%] text-customGray flex items-center gap-[6px]">
                        {professionNames ?? "--"}
                      </span>
                    </li>
                    <li className="flex items-center mb-[14px] gap-[10px]">
                      <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                        Status
                      </h6>
                      <span
                        className={`inline-flex items-center capitalize rounded-md px-[10px] py-1 text-xs font-bold leading-[160%] ${getStatusClasses(
                          person.status
                        )}`}
                      >
                        {person.status}
                      </span>
                    </li>
                    {person.invoice_pdf && (
                      <li className="flex items-center gap-[10px]">
                        <h6 className="w-[100px] text-sm font-bold leading-[160%] text-[#485868]">
                          View
                        </h6>
                        <ArrowDownTrayIcon
                          onClick={() =>
                            window.open(person.invoice_pdf, "_self")
                          }
                          className="w-6 h-6 text-primary inline-block"
                        />
                        <Link
                          className="text-sm font-bold leading-[160%] text-primary flex items-center gap-[6px]"
                          to={person.invoice_pdf}
                        >
                          Download
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>
              ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default ProfessionalInvoiceTable;
